<template>
  <div>
    <el-dialog title="电子保修卡审批" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="50%"
               style="position: absolute; top: -90px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose"
               v-el-drag-dialog
               v-el-dialog-center>

      <div class="detail-wrap">
        <div class="d-header clearfix" style="margin-bottom: 16px">
          <div class="fl">
            <i class="el-icon-info" style="color: #00c4b3;"/>
            产品条码:{{order.barcode}}
            <el-tag>审核中</el-tag>
          </div>
        </div>
        <div class="line">
          <div class="key">手机号:</div>
          <span>{{order.callMobile}}</span>
        </div>
        <div class="line">
          <div class="key">产品品牌:</div>
          <span>{{order.brandName}}</span>
        </div>
        <div class="line">
          <div class="key">产品品类:</div>
          <span>{{order.bigCategoryName}}</span>
        </div>
        <div class="line">
          <div class="key">产品型号:</div>
          <span>{{order.itemModel}}</span>
        </div>
        <div class="line">
          <divdiv class="key">购买日期:</divdiv>
          <span>{{order.applyBuyDate}}</span>
        </div>
        <div class="line">
          <div class="key">安装地址:</div>
          <span>{{order.applyFullAddress}}</span>
        </div>
        <div class="line">
          <div class="key">凭证图片:</div>
          <div class="img-list">
            <div class="img-item" v-if="order.pic1">
              <img :src="order.pic1" @click="perView(order.pic1)">
            </div>
            <div class="img-item" v-if="order.pic2">
              <img :src="order.pic2" @click="perView(order.pic2)">
            </div>
            <div class="img-item" v-if="order.pic3">
              <img :src="order.pic3" @click="perView(order.pic3)">
            </div>
          </div>
        </div>
        <div class="line">
          <div class="key">审核类型:</div>
          <el-radio-group disabled v-model="order.checkType">
            <el-radio :label="1">无资产无工单</el-radio>
            <el-radio :label="2">有资产无工单</el-radio>
            <el-radio :label="3">有工单无资产</el-radio>
            <el-radio :label="4">有资产有工单</el-radio>
          </el-radio-group>
        </div>
        <div class="line">
          <div class="key must">审批结果:</div>
          <el-radio-group v-model="order.checkStat">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </div>
        <div class="line" v-if="order.checkStat && order.checkStat === 1">
          <div class="key must">二次销售/出库记录:</div>
          <el-radio-group v-model="order.doubleSale">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">有</el-radio>
          </el-radio-group>
        </div>
        <div class="line" v-if="order.checkStat && order.checkStat === 1">
          <div class="key must">保修卡类型:</div>
          <el-radio-group v-model="order.cardType">
            <el-radio :label="1">主卡</el-radio>
            <el-radio :label="2">副卡</el-radio>
          </el-radio-group>
        </div>
        <div class="line" v-if="order.checkStat === 2">
          <div class="key must">不通过原因:</div>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="order.nopassReason">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain class="button-sty" @click="dialogClose">
          <i class="el-icon-close el-icon"></i>
          取 消
        </el-button>
        <el-button type="primary" @click="commitData" class="button-sty">
          <i class="el-icon-check el-icon"></i>
          确 定
        </el-button>
      </span>
    </el-dialog>

    <el-image-viewer
      v-if="viewerDialogVisible"
      :on-close="closeImgViewer"
      :url-list="dialogImageUrlList"/>
  </div>
</template>

<script>
import api from "@/api/projectApi";
import request from "@/router/axios";



export default {
  name: 'checkEditDialog',
  props: ['order'],
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      showDialog: true,
      falseValue: false,
      viewerDialogVisible: false,
      dialogImageUrlList: [],
    };
  },


  methods: {
    dialogClose() {
      this.$emit('closeEdit')
    },
    perView(url) {
      this.dialogImageUrlList = [url]
      this.viewerDialogVisible = true
    },
    closeImgViewer() {
      this.viewerDialogVisible = false
    },
    commitData() {
      if(!this.order.checkStat) return this.$message.error('请选择审批结果')
      if(this.order.doubleSale != 0 && this.order.doubleSale != 1) return this.$message.error('请选择二次销售/出库记录')
      if(!this.order.cardType) return this.$message.error('请选择保修卡类型')
      // if(!this.order.checkType) return this.$message.error('请选择审核类型')
      if(this.order.checkStat === 2 && !this.order.nopassReason) return this.$message.error('请输入不通过原因')

      request({
        url: api.warrantyCardCheck.handleCheck,
        method: 'post',
        data: {
          assetId: this.order.assetId,
          checkStat: this.order.checkStat,
          nopassReason: this.order.nopassReason,
          doubleSale: this.order.doubleSale,
          cardType: this.order.cardType,
          // checkType: this.order.checkType,
        },
        isLoading: true,
      }).then(res => {
        const { code, msg } = res.data;
        if(code === 0) {
          this.$message.success('审批成功')
          this.$emit('closeEdit')
        }else {
          this.$message.error(msg)
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 7vw;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -50px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

::v-deep .el-cascader--medium {
  font-size: 14px;
  line-height: 36px;
  // width: 25vw !important;
}

::v-deep .adress .el-cascader .el-input .el-input__inner {
  text-overflow: ellipsis;
  // width: 25vw !important;
}

.line{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;

  .key{
    margin-right: 10px;
  }

  .must{
    position: relative;

    &:before{
      content: '*';
      color: red;
      position: absolute;
      top: 0;
      left: -6px;
    }
  }

  .img-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .img-item{
      width: 80px;
      height: 80px;
      overflow: hidden;
      margin-right: 4px;

      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

::v-deep .el-dialog__wrapper{
  z-index: 2000!important;
}
</style>
